module.exports = __webpack_public_path__ + "img/x-black.483f5ecc.svg";